import React from 'react';

export interface EmptyNoteProps {
  message: string;
  action?: React.ReactNode;
}

/** Dashed placeholder for a list that has nothing in it yet. */
export const EmptyNote: React.FC<EmptyNoteProps> = ({ message, action }) => (
  <div className="flex flex-col items-center gap-3 rounded-2xl border border-dashed border-[#E0E0E0] px-6 py-8 text-center">
    <p className="text-sm text-[#666666]">{message}</p>
    {action}
  </div>
);

export default EmptyNote;
